<template>
  <div id="guess-checker">
    <!-- Submit guess: The answer to this puzzle is {{answer}} -->
    <!-- {{ answer }}
    {{ simple }} -->
    <form id="guess-form" @submit.prevent="checkGuess">
      <input v-model="guess" type="text" id="guess" :class="[{simple: simple}]" :placeholder="placeholder" maxlength="50" autocomplete="off">
      <input type="submit" id="submit" :class="[{simple: simple}]" value="submit">
    </form>
    <div id="guess-feedback" v-html="feedback">
      <!-- {{ feedback }} -->
    </div>
  </div>
</template>

<script>
import bcrypt from 'bcryptjs'

export default {
  name: 'GuessChecker',
  props: {
    answer: String,
    simple: {
      default: false
    },
  },
  computed: {
    placeholder() {
      return this.simple? this.simple : 'submit guess'
    }
  },
  methods: {
    checkGuess: function() {
      
      const guess = this.guess.toUpperCase().replace(/[^A-Z]/gi, '')

      const feedbackStrings = {
        simple: {
          empty: "",
          correct: "<span class='correct'>"+guess+"</span>",
          incorrect: "<span class='incorrect'>incorrect!</span>",
        },
        verbose: {
          empty: "Your guess is empty. The answer is an English word or phrase, case insensitive, stripped of all non-alpha characters.",
          correct: "🎉 Your guess, <span class='correct'>" + guess + "</span>, is correct! 🎉",
          incorrect: "Your guess, <span class='incorrect'>" + guess + "</span>, is incorrect.",
        }
      }

      // load feedback object with either verbose or simple responses based on the simple prop being false or not
      const feedback = this.simple? feedbackStrings.simple : feedbackStrings.verbose

      if (guess == "") {
        this.feedback = feedback.empty
        return
      }

      const check = bcrypt.compareSync(guess, this.answer)
      // console.log(check)


      if (check) {
        this.feedback = feedback.correct
      } else {
        this.feedback = feedback.incorrect
      }

      // clear guess
      this.guess = ''

    }
  },
  data: function() {
    return {
      guess: '',
      feedback: ''
    }
  }
}
</script>

<style lang="scss" scoped>

  input {
    padding: 3px;
    border: 0;
    border-radius: 5px;

    font-family: MyriadPro, Helvetica, Arial, sans-serif;
    font-size: 22px;
    &.simple {
      font-size: 14px;
    }

    &#guess {
      width: 220px;
      background: #fff;
      color: #101;
    }

    &#submit {
      // width: 80px;
      background: rgb(119, 119, 119);
      color: #fff;
      padding: 3px 10px;
    }

  }


  #guess-form {
    display:flex;
    align-items: center;
    justify-content: center;
    flex-wrap:wrap;
    padding: 10px;
  }

  #guess-feedback {
    font-style: italic;
    text-align: center;
    >>> .correct {
      font-weight: bold;
      color: rgb(19, 150, 67);
    }

    >>> .incorrect {
      font-weight: bold;
      color: #FF2222;
    }
  }

  
</style>